import React, {
    useState,
    useEffect,
    useContext,
    useCallback,
    useMemo,
} from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { useMediaQuery } from 'react-responsive';

import ListVehicleCard from '../components/shared/vehicleCard/ListVehicleCard';
import TagFilters from '../components/vehicleFilters/TagFilters';
import AdvancedFilters from '../components/vehicleFilters/AdvancedFilters';
import Button from '../components/bronson/Button';
import { withCookies } from 'react-cookie';
import Loading from '../components/bronson/Loading';
import CustomMessage from '../components/shared/CustomMessage';
import ParseService from '../services/ParseService';
import Traductor from '../components/Traductor';
import VehicleService from '../services/VehicleService';
import { UserContext } from '../contexts/UserContext';
import { VehiclesContext } from '../contexts/VehiclesContext';
import {
    filterBrands,
    filterModels,
    filterOrder,
    filterDealers,
    filterComercialProducts,
    filterVIN,
    filterPlate,
    filterWarrantyExtension,
    filterDatePurchaseOptionFrom,
    filterFinancialOperation,
} from '../constants/Filters';
import Globals from '../Globals';
import VehicleFilters from '../components/vehicleFilters/VehicleFilters';
import ScrollToTop from '../components/ScrollToTop';

import * as filtersActions from '../redux/actions/filters';
import { makeGetCountSelectedFilters } from '../redux/selectors/filters';
import useServerTime from 'hooks/useServerTime';

const DealerReceptorPage = ({
    history,
    cookies,
    filters,
    filtersOptions,
    filtersCount,
    setFilters,
    setInitialFilters,
    initialFilters,
}) => {
    const isMobileOrTablet = useMediaQuery({ maxWidth: 960 });
    const t = useMemo(() => new Traductor(), []);
    const { user } = useContext(UserContext);
    const { contextListVehicles, setContextListVehicles } = useContext(
        VehiclesContext
    );
    const [advancedFilters, setAdvancedFilters] = useState(false);
    const [loading, setLoading] = useState(true);
    const [firstLoad, setFirstLoad] = useState(true);
    const [lastNumberVehicles, setLastNumberVehicles] = useState(0);
    const { serverTime, fetchServerTime } = useServerTime(true);
    const availableFilters = useMemo(
        () => ({
            principal: [
                filterComercialProducts,
                filterFinancialOperation,
                filterDealers,
                filterBrands,
                filterModels,
                filterDatePurchaseOptionFrom,
            ],
            advanced: [
                filterComercialProducts,
                filterFinancialOperation,
                filterDealers,
                filterBrands,
                filterModels,
                filterDatePurchaseOptionFrom,
                filterPlate,
                filterVIN,
                filterWarrantyExtension,
            ],
        }),
        []
    );

    const checkNumberReceptorVehicles = useCallback(async () => {
        setLoading(true);
        await new VehicleService()
            .getNumberDealerReceptor(
                cookies.get(Globals.COOKIES.JWT).AccessToken,
                filters
            )
            .then(response => {
                let lastNumber = -1;
                if (response && response.Result != null) {
                    if (parseInt(response.Result) > 0) lastNumber = 0;
                }
                setLastNumberVehicles(lastNumber);
                setLoading(false);
            });
    }, [cookies, filters]);

    const getListVehicles = useCallback(async () => {
        if (!filtersOptions.Dealers || firstLoad) return null;
        setLoading(true);

        const filterDealersCheck = {
            ...filters,
            isDealer: user.data.Profile === 12,
        };

        if (
            filtersOptions?.Dealers?.length &&
            !filterDealersCheck[filterDealers].length
        ) {
            filterDealersCheck[filterDealers] = filtersOptions.Dealers.map(
                e => e.Id
            );
        }

        const response = await new VehicleService().getVehiclesDealerReceptor(
            cookies.get(Globals.COOKIES.JWT).AccessToken,
            filterDealersCheck
        );
        if (response) {
            const vehicles = new ParseService().Parse(response.Result);

            if (vehicles) {
                setContextListVehicles(vehicles);
                if (vehicles.length > 0 && vehicles[0].TotalCount) {
                    setLastNumberVehicles(vehicles[0].TotalCount);
                } else {
                    setLastNumberVehicles(vehicles.length);
                }
            } else {
                checkNumberReceptorVehicles(filters);
            }
        }
        setLoading(false);
    }, [
        checkNumberReceptorVehicles,
        cookies,
        filters,
        filtersOptions.Dealers,
        firstLoad,
        setContextListVehicles,
        user.data.Profile,
    ]);

    const getFilters = useCallback(async () => {
        if (user.data.Empleado) {
            const userData = {
                isDealer: user.data.Profile === 12,
                idEmploye: user?.data?.Empleado?.Id || null,
            };
            await new VehicleService()
                .getFiltersDealerReceptor(
                    cookies.get(Globals.COOKIES.JWT).AccessToken,
                    userData
                )
                .then(response => {
                    let newFiltersOptions = [];
                    if (response && response.body.Result != null) {
                        newFiltersOptions = new ParseService().Parse(
                            response.body.Result
                        );
                        newFiltersOptions = {
                            ...newFiltersOptions,
                            Plate: '',
                            VIN: '',
                            WarrantyExtension: '',
                        };

                        setInitialFilters({
                            options: { ...newFiltersOptions },
                        });

                        setFirstLoad(false);
                    }
                });
        }
    }, [cookies, setInitialFilters, user.data.Empleado, user.data.Profile]);

    useEffect(() => {
        if (user.data.Profile && user.data.Profile !== 12)
            history.push(Globals.APPLICATION_PATH.HOME);
        if (Object.keys(user.data).length > 0) getFilters();
    }, [user.data, history]);

    useEffect(() => {
        getListVehicles();
    }, [filters, getListVehicles]);

    const onAdvancedFiltersPress = useCallback(() => {
        setAdvancedFilters(currentStatus => !currentStatus);
    }, []);

    const refreshFilters = useCallback(
        newFiltersOptions => {
            setFilters({
                ...newFiltersOptions,
                [filterOrder]: { ...newFiltersOptions[filterOrder], Page: 1 },
            });
        },
        [setFilters]
    );

    const printAdvancedFilters = () => {
        if (!advancedFilters) return null;
        return (
            <AdvancedFilters
                refreshFilters={refreshFilters}
                filters={filters}
                filtersOptions={filtersOptions}
                countSelectedFilters={filtersCount}
                updateFilters={setFilters}
                setInitialFilters={setInitialFilters}
                closeAdvancedFilters={onAdvancedFiltersPress}
                resetFilters={resetFilters}
                availableFilters={availableFilters.advanced}
            />
        );
    };

    const printAdvantedFiltersInDesktop = useCallback(() => {
        if (isMobileOrTablet && Object.keys(filters).length > 0) {
            let optionsAdvancedFilters = {
                text:
                    t.getTraduction('AdvancedFilters') +
                    ' ' +
                    (filtersCount > 0 ? '(' + filtersCount + ')' : ''),
                class: 'c-btn--full',
            };

            return (
                <div className="o-layout">
                    <div className="o-layout__item">
                        <Button
                            options={optionsAdvancedFilters}
                            onClick={onAdvancedFiltersPress}
                        />
                    </div>
                </div>
            );
        }
    }, [isMobileOrTablet, onAdvancedFiltersPress, filters, filtersCount, t]);

    const resetFilters = useCallback(
        returnData => {
            setFilters({ ...initialFilters });
            if (returnData) {
                return initialFilters;
            }
        },
        [initialFilters, setFilters]
    );

    const printTagFilters = useCallback(() => {
        return (
            <div id="TagFiltersList" className="o-layout__item u-8/12 u-1/1@m">
                <ul className="c-tag-list">
                    <TagFilters
                        /*refreshFilters={refreshFilters}*/
                        filters={filters}
                        filtersOptions={filtersOptions}
                        resetFilters={resetFilters}
                    />
                </ul>
            </div>
        );
    }, [filters, filtersOptions, resetFilters]);

    const printWithoutVehiclesMessage = useCallback(() => {
        if (
            loading ||
            (!loading &&
                contextListVehicles != null &&
                contextListVehicles.length > 0)
        )
            return null;
        let options = {};
        if (lastNumberVehicles === 0) {
            options = {
                title: t.getTraduction('WithoutVehicles_title'),
                body: t.getTraduction('WithoutVehicles_body2'),
                icon: 'no-vehicles',
                primaryButton: {
                    options: {
                        btnTypes: ['secondary'],
                        text: t.getTraduction('ResetFilters'),
                    },
                    onClick: resetFilters,
                },
            };
        } else if (lastNumberVehicles < 0) {
            options = {
                title: t.getTraduction('WithoutVehiclesReturnDealers_title'),
                body: t.getTraduction('WithoutVehiclesReturnDealers_body'),
                icon: 'no-vehicles',
            };
        }

        return <CustomMessage options={options} />;
    }, [contextListVehicles, lastNumberVehicles, loading, resetFilters, t]);

    const printAlertOrFilterButtons = () => {
        if (!isMobileOrTablet) return null;

        let optionsAdvancedFiltersMobile = {
            text:
                t.getTraduction('Filters') +
                ' ' +
                (filtersCount > 0 ? '(' + filtersCount + ')' : ''),
            class: 'c-btn--full',
        };

        return (
            <Button
                options={optionsAdvancedFiltersMobile}
                onClick={onAdvancedFiltersPress}
            />
        );
    };

    const printPrincipalFilters = useCallback(() => {
        if (!filters) return null;
        return (
            <VehicleFilters
                refreshFilters={refreshFilters}
                updateFilters={setFilters}
                setInitialFilters={setInitialFilters}
                filters={filters}
                filtersOptions={filtersOptions}
                availableFilters={availableFilters.principal}
            />
        );
    }, [
        availableFilters.principal,
        filters,
        filtersOptions,
        refreshFilters,
        setFilters,
        setInitialFilters,
    ]);

    const changeCurrentPage = useCallback(
        page => {
            setFilters({
                ...filters,
                filterOrder: { ...filters[filterOrder], Page: page },
            });
        },
        [filters, setFilters]
    );

    return (
        <>
            <ScrollToTop />
            <section
                className="o-content-section u-pt-small u-rema-full-height"
                data-testid="dealerReceptorPageTestId"
            >
                <div className="o-page-wrap o-page-wrap--xsmall">
                    <div className="o-layout">
                        <div className="o-layout__item u-1/1">
                            <p className="u-h3">
                                {t.getTraduction(
                                    'PurchaseOptionReceiverDealer'
                                )}
                            </p>
                        </div>
                    </div>
                    <div className="o-layout u-mb u-mt">
                        {!isMobileOrTablet ? printTagFilters() : null}
                        <div className="o-layout__item u-1/12 u-1/1@m">
                            {printAlertOrFilterButtons()}
                        </div>
                        <div className="o-layout__item u-3/12 u-hide@m"></div>
                        {isMobileOrTablet ? printTagFilters() : null}
                    </div>
                    <div className="o-layout">
                        <div className="o-layout__item u-1/5 u-3/12@l u-hide@m">
                            {printPrincipalFilters()}
                            {printAdvantedFiltersInDesktop()}
                        </div>
                        <div className="o-layout__item u-4/5 u-9/12@l u-1/1@m">
                            {printWithoutVehiclesMessage()}
                            <ListVehicleCard
                                vehicleList={contextListVehicles}
                                isLoading={loading}
                                history={history}
                                parentCurrentPage={filters[filterOrder].Page}
                                changeParentCurrentPage={changeCurrentPage}
                                limitVehicles={initialFilters.initCountVehicles}
                                lastNumberVehicles={lastNumberVehicles}
                                options={{ typeCards: 'dealerReceptor' }}
                                serverTime={serverTime}
                                fetchServerTime={fetchServerTime}
                            />
                        </div>
                    </div>
                </div>
            </section>
            {printAdvancedFilters()}
            <Loading ariaBusy={loading} disableIcon={true} />
        </>
    );
};

const makeMapStateToProps = () => {
    const getCountSelectedFilters = makeGetCountSelectedFilters(
        Globals.APPLICATION_PATH.RECEIVINGDEALER
    );
    const mapStateToProps = (state, props) => {
        return {
            filtersCount: getCountSelectedFilters(state, props),
            filters:
                state.filters[Globals.APPLICATION_PATH.RECEIVINGDEALER]
                    .selected,
            filtersOptions:
                state.filters[Globals.APPLICATION_PATH.RECEIVINGDEALER].options,
            initialFilters:
                state.filters[Globals.APPLICATION_PATH.RECEIVINGDEALER].initial,
        };
    };
    return mapStateToProps;
};

const mapDispatchToProps = (dispatch, ownProps) => ({
    ...bindActionCreators({ ...filtersActions }, args => {
        //inject key with page route to actions
        return dispatch({
            ...args,
            route: Globals.APPLICATION_PATH.RECEIVINGDEALER,
        });
    }),
});

export default withCookies(
    withRouter(
        connect(makeMapStateToProps, mapDispatchToProps)(DealerReceptorPage)
    )
);
